import React from 'react';



export const data = [
  {
    question: 'How to Reset forgotten password?',
    answer: (
      <ul>
        <li>Click FORGOT PASSWORD on your screen</li>
        <li>Enter EMAIL ADDRESS </li>
        <li>Click SEND RESET LINK </li>
        <li>A password reset link will be sent to your FAAN email address, click the link </li>
        <li>Enter your NEW PASSWORD </li>
      </ul>
    ),
  },
    {
      question: 'How to Change AviCollect Password?',
      answer:[
              <ul>
                <li>Click the profile ICON on the top right corner of your screen to reveal dropdown, click RESET PASSWORD.  </li>
                <li>Enter your CURRENT PASSWORD </li>
                <li>Enter your NEW PASSWORD </li>
                <li>Confirm your NEW PASSWORD </li>
                <li>Click CHANGE </li>
              </ul>
      ]
    },
  
    {
      question: 'How to View Manifest Report?',
      answer:[
        <ul>
          <li> Select MANIFEST REPORT from the drop down on the left side on your screen </li>
          <li>Select START and END DATE in the calendar drop down </li>
          <li>Select SPECIFIC CATEGORY</li>
          <li>Select DATE TYPE </li>
          <li>Click the SEARCH Button  </li>
        </ul>
      ]           
    }, 
  
    {
      question: 'How To View Daily Report?',
      answer:[
        <ul>
          <li>Click on REPORT from the drop down on the left side on your screen </li>
          <li>Select START and END DATE in the calendar drop down</li>
          <li>Select TRAVEL ROUTE  </li>
          <li>Click SEARCH Button  </li>
        </ul>

      ]
           
    },
    
    {
      question: 'How to View IATA Report?',
      answer:[
          <ul>
            <li>Click on IATA REPORT from the Menu bar on the left side on your screen </li>
            <li>Enter Type of Flight - DOMESTIC or INTERNATIONAL</li>
            <li>Select TYPE OF AIRLINE </li>
            <li>Select AIRPORT</li>
            <li>Select DESTINATION AIRPORT </li>
            <li>Enter recipients EMAIL ADDRESS </li>
            <li>Select START and END DATE from Calendar drop down </li>
            <li>Click GENERATE </li>
            <li>The report will be generated and sent to the recipient's mailing address as provided. </li>
          </ul>
          ]
    },

    {
      question: 'How to POST DEPARTURE MANIFEST?',
      answer:[
            <ul>
              <li>Click PDM from the Menu bar on the left side on your screen to view REPORT </li>
              <li>Click REPORT </li>
              <li>Select START and END DATE  </li>
              <li>Select CATEGORY </li>
              <li>Click SEARCH BUTTON </li>      
            </ul>
          ]
    },

    {
      question: 'HOW TO INPUT PDM DATA ENTRY ',
      answer:[
            <ul>
              <li>Click on DATA Entry under PDM </li>
              <li>Enter the following details
                <li>Airline </li>
                <li>Flight Number </li>
                <li>Flight Date </li>
                <li>Destination Airport </li>
                <li>Departure Airport </li>
                <li>Pax Count </li>
                <li>TSC Amount </li>
                <li>Currency  </li>
              </li>
              <li>Click SAVE Button </li>
              <li>Click PROCEED after confirmation of all details provided </li>
              <li>A prompt is displayed to show if combination entries exist and is successful </li>
              <li>Click OK </li>
            </ul>
          ]
    },

    {
      question: 'How to View Billed Per Airport?',
      answer:[
        <ul>
          <li>Click BILLED PER AIRPORT </li>
          <li>Select the following details required in the display:  
            <li>Month </li>
            <li>Airline  </li>
            <li>Source Airport </li>
          </li>
        </ul>    
          ]
    },

  ]



// WEBPACK FOOTER //
// ./src/views/pages/faqs/data.js